import { Component, Input, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { NewsletterCategory } from "src/app/intefaces/newsletter-category";
import { AuthorizationService } from "src/app/services/authorization.service";
import { HttpAlertService } from "src/app/services/http-alert.service";
import { NewsletterService } from "src/app/services/newsletter.service";

@Component({
  selector: "app-newsletter-options",
  templateUrl: "./newsletter-options.component.html",
  styleUrls: ["./newsletter-options.component.scss"],
})
export class NewsletterOptionsComponent implements OnInit {
  login = this.authService.isLogin();
  private subscription: Subscription = new Subscription();
  categories: NewsletterCategory[] = [];

  selectedCategories: number[] = [];
  @Input() key: string = null;
  @Input() adminUserId: number = null;
  loading = true;

  constructor(
    private readonly authService: AuthorizationService,
    private readonly newsletterService: NewsletterService,
    private readonly alterService: HttpAlertService
  ) {}

  ngOnInit() {
    this.isLoginObservable();
    this.getCategories();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  private getCategories() {
    const sub = this.newsletterService
      .getCategories(this.login, this.key, this.adminUserId)
      .subscribe({
        next: (data) => {
          this.categories = data.data.categories;
          this.selectedCategories = data.data.user_active_optins;
        },
        complete: () => {
          this.loading = false;
        },
      });
    this.subscription.add(sub);
  }

  private isLoginObservable() {
    const auth = this.authService.isLoginObservable().subscribe({
      next: (data) => {
        this.login = data;
      },
    });
    this.subscription.add(auth);
  }

  public onSubmit() {
    this.newsletterService
      .updateOptions(
        this.login,
        this.selectedCategories,
        this.key,
        this.adminUserId
      )
      .subscribe({
        next: () => {
          this.alterService.info("newsletter_saved");
        },
      });
  }

  onChange() {
    this.onSubmit();
  }
}
